import React, { PureComponent } from 'react';
import { DialogContainer, TextField, CircularProgress } from 'react-md';

const DEFAULT_RULE_POINTS = 'everyone'
const DEFAULT_RULE_STUCK = 'player'

export default class ChangeNameDialog extends PureComponent {
    state = {
      loading: false,
      value: this.props.value,
      rulePoints: DEFAULT_RULE_POINTS,
      ruleStuck: DEFAULT_RULE_STUCK
    };

    onDialogHidden = () => {}

    submit = () => {
        
        const { value } = this.state;

        this.setState({ loading: true });

        if (this.props.onSubmit) {
            this.props.onSubmit(value).then(() => {
              this.setState({ loading: false });
            });
        }
    }

    handleValueChange = (value) => {
        
        this.setState({ value });
    }

    onFocus = (event) => event.target.select();
  
    render() {
      
      const actions = [{
        id: 'dialog-cancel',
        secondary: true,
        children: 'Cancel',
        onClick: this.props.onCancel,
        disabled: this.state.loading
      }, {
        id: 'dialog-ok',
        secondary: true,
        children: 'Ok',
        onClick: this.submit,
        disabled: this.state.loading
      }];

      const itemLoading = <CircularProgress id='progress'/>;

      const itemContents = <TextField
        id="field-1"
        label={this.props.label}
        value={this.state.value}
        onChange={this.handleValueChange}
        onFocus={this.onFocus}
        className="md-cell md-cell--12" />;

        return <DialogContainer
            id="field-dialog-change-name"
            title={this.props.title}
            visible={this.props.visible}
            actions={actions}
            onHide={this.onDialogHidden}
            contentClassName="md-grid"
        >
            {this.state.loading ? itemLoading : itemContents}
        </DialogContainer>;
    }
}


// WEBPACK FOOTER //
// ./src/ChangeNameDialog.jsx